export default "__VITE_ASSET__BIb8DGxV__"